import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { RouteComponentProps } from 'react-router-dom'
import { history, IAppState } from '../../redux/store'
import { IPageData, IPageProps } from '../../interfaces/page-data'
import { IPaginationBaseState, TextFormat } from 'react-jhipster'
import { DEFAULT_ITEMS_PER_PAGE, ITEMS_PER_PAGE } from '../../utils/pagination.constants'
import { getEntities } from '../../shared/reducers/model/extended/tournament.extended.reducer'
import { getEntities as getEvents } from '../../shared/reducers/model/event.reducer'
import { getEntities as getDisciplines } from '../../shared/reducers/model/discipline.reducer'
import { getEntities as getCategories } from '../../shared/reducers/model/tournament-category.reducer'
import { TournamentStatus } from '../../shared/model/enumerations/tournament-status.model'
import { Col, Dropdown, Input, Menu, message, Row, Space, Table, Tooltip } from 'antd'
import Button from 'antd/es/button'
import { DownOutlined, ReloadOutlined, SearchOutlined } from '@ant-design/icons'
import { ITournamentExtended } from '../../shared/model/extended/tournament.extended.model'
import { APP_LOCAL_DATE_FORMAT_EU } from '../../redux/settings/constants'
import { EventStatus } from '../../shared/model/enumerations/event-status.model'

const SHOW_RANKING = 'SHOW_RANKING'
const EXPORT_FLOWCHART = 'EXPORT_FLOWCHART'

export interface IActiveTournamentsProps extends IPageProps, StateProps, DispatchProps, RouteComponentProps<{ url: string }> {
}

const ActiveTournaments = (props: IActiveTournamentsProps) => {

  const pageData: IPageData = {
    title: 'Archived Tournaments',
    loaded: false,
    breadcrumbs: [
      {
        title: 'BitsButler',
        route: '/',
      },
      {
        title: 'Tournaments',
      },
      {
        title: 'Archive',
      },
    ],
  }

  const [paginationState, setPaginationState] = useState<IPaginationBaseState>({
    itemsPerPage: ITEMS_PER_PAGE,
    activePage: 1,
    sort: 'tournamentStartDate',
    order: 'desc',
  })

  const [tableFilters, setTableFilters] = useState({
    tournamentStatus: [TournamentStatus.APPROVED, TournamentStatus.CANCELED],
  })

  const { onSetPage } = props
  useEffect(() => {
    onSetPage(pageData)
    loadEntities()
    loadEventsFilters()
    loadDisciplines()
    loadCategories()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    // console.log('useEffect: UpcomingTournaments - location')
    onSetPage({ ...pageData, loaded: true })
    loadEntities()
    loadEventsFilters()
    loadDisciplines()
    loadCategories()
  }, [props.location]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    // console.log('useEffect: UpcomingTournaments - loading')
    if (!props.loading)
      onSetPage({ ...pageData, loaded: true })
  }, [props.loading])

  useEffect(() => {
    loadEntities()
  }, [paginationState, tableFilters])

  const [eventFilters, setEventFilters] = useState([])
  useEffect(() => {
    if (!props.eventsLoading && props.events && props.events.length > 0)
      setEventFilters(props.events.map(event => ({
        text: event.name,
        value: event.id,
      })))
  }, [props.eventsLoading])

  const [disciplineFilters, setDisciplineFilters] = useState([])
  useEffect(() => {
    if (!props.disciplinesLoading && props.disciplines && props.disciplines.length > 0)
      setDisciplineFilters(props.disciplines.map(discipline => ({
        text: discipline.name,
        value: discipline.id,
      })))
  }, [props.disciplinesLoading])

  const [categoryFilters, setCategoryFilters] = useState([])
  useEffect(() => {
    if (!props.categoriesLoading && props.categories && props.categories.length > 0)
      setCategoryFilters(props.categories.map(category => ({
        text: category.name,
        value: category.id,
      })))
  }, [props.categoriesLoading])

  const loadEntities = () => {
    // console.log('load tournaments', tableFilters)
    // @ts-ignore
    props.getEntities(paginationState.activePage - 1, paginationState.itemsPerPage, `${paginationState.sort},${paginationState.order}`, tableFilters)
  }

  const loadEventsFilters = () => {
    // @ts-ignore
    props.getEvents(0, 99, 'eventStartDate,desc', {
      eventStatus: [EventStatus.RUNNING, EventStatus.APPROVED, EventStatus.CANCELED],
    })
  }

  const loadDisciplines = () => {
    props.getDisciplines(0, 99, 'name')
  }

  const loadCategories = () => {
    props.getCategories(0, 99, 'name')
  }

  const actionMenu = (tournament: ITournamentExtended) => {
    const disableBtnFlowchart = tournament.tournamentStatus === TournamentStatus.CREATED

    return <Menu onClick={evt => handleMenuClick(evt, tournament)}>
      <Menu.Item key={SHOW_RANKING}>Show Ranking</Menu.Item>
      <Menu.Item key={EXPORT_FLOWCHART}
                 disabled={disableBtnFlowchart}>
        Download Flowchart
      </Menu.Item>
    </Menu>
  }

  const handleMenuClick = (evt, tournament: ITournamentExtended) => {
    switch (evt.key) {
      case SHOW_RANKING:
        history.push(`/app/tournaments/archive/${tournament.id}/ranking`)
        break
      case EXPORT_FLOWCHART:
        history.push(`/app/tournaments/archive/${tournament.id}/export`)
        break
      default:
        message.error('invalid action')
    }
  }

  const handleTableChange = (pagination, filters, sorter) => {
    setPaginationState({
      ...paginationState,
      activePage: pagination.current,
      sort: sorter?.order !== undefined ? sorter.field : '',
      order: sorter?.order !== undefined ? sorter.order === 'ascend' ? 'asc' : sorter.order === 'descend' ? 'desc' : null : '',
    })
    setTableFilters({
      ...tableFilters,
      ...filters,
    })
  }

  let searchInput
  const getColumnSearchProps = dataIndex => ({
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <Input ref={node => {
            searchInput = node
          }}
                 placeholder={`Search ${dataIndex}`}
                 value={selectedKeys[0]}
                 onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                 onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                 style={{ width: 188, marginBottom: 8, display: 'block' }}
          />
          <Space>
            <Button type="primary"
                    onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    icon={<SearchOutlined/>}
                    size="small"
                    style={{ width: 90 }}
            >
              Search
            </Button>
            <Button onClick={() => handleReset(clearFilters, dataIndex)} size="small" style={{ width: 90 }}>
              Reset
            </Button>
          </Space>
        </div>
      ),
      filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }}/>,
      onFilterDropdownVisibleChange: visible => {
        if (visible) {
          setTimeout(() => searchInput.select(), 100)
        }
      },
    }
  )

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    // console.log('handleSearch', selectedKeys)
    confirm()
    if (selectedKeys[0] === '')
      delete tableFilters[dataIndex]
    else
      tableFilters[dataIndex] = selectedKeys[0]
    setTableFilters({
      ...tableFilters,
    })
  }

  const handleReset = (clearFields, dataIndex) => {
    delete tableFilters[dataIndex]
    clearFields()
  }

  const handleShowCreateTournament = () => {
    history.push(`${props.match.url}/create`)
  }

  const handleShowEditTournament = (tournamentId: number) => {
    history.push(`${props.match.url}/${tournamentId}/edit`)
  }

  return (
    <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
      <Col span={24} style={{ textAlign: 'right', marginBottom: 8 }}>
        <Space>
          <Tooltip placement="top" title="Refresh List">
            <Button icon={<ReloadOutlined style={{ fontSize: 24 }}/>} type="text" onClick={loadEntities}/>
          </Tooltip>
        </Space>
      </Col>
      <Col span={24}>
        <Table id={'activeTournamentsTable'} size={'small'} showSorterTooltip
               rowKey={'id'}
               loading={props.loading}
               dataSource={props.entities.flat()}
          /*
                         rowSelection={{
                           selectedRowKeys: selectedMatches,
                           onChange: handleSelectChange,
                         }}
          */
               onChange={handleTableChange}
               pagination={{
                 defaultPageSize: DEFAULT_ITEMS_PER_PAGE,
                 total: props.totalItems,
                 pageSize: paginationState.itemsPerPage,
               }}
        >
          <Table.Column<ITournamentExtended> key={'mnemonic'} dataIndex={'mnemonic'} title={''}/>
          <Table.Column<ITournamentExtended> key={'tournamentName'} dataIndex={'name'} title={'Name'}
                                             {...getColumnSearchProps('name')}
          />
          <Table.Column<ITournamentExtended> key={'tournamentStartDate'} dataIndex={'tournamentStartDate'}
                                             title={'Start-Date'}
                                             sorter defaultSortOrder={'descend'}
                                             width={'150px'}
                                             render={(value) => <TextFormat value={value} type={'date'}
                                                                            format={APP_LOCAL_DATE_FORMAT_EU}/>}
          />
          <Table.Column<ITournamentExtended> key={'participants'} dataIndex={'entryLimit'} title={'Participants'}
                                             render={(value, row) => `${row.numberOfParticipants}/${value}`}
          />
          <Table.Column<ITournamentExtended> key={'raceTo'} dataIndex={'raceTo'} title={'Race to'} width={75} align={'center'}/>
          <Table.Column<ITournamentExtended> key={'tournamentCategoryId'} dataIndex={'tournamentCategoryId'}
                                             title={'Classification'}
                                             width={200}
                                             filters={categoryFilters}
                                             render={(value, row) => row.tournamentCategoryName}
          />
          <Table.Column<ITournamentExtended> key={'disciplineId'} dataIndex={'disciplineId'} title={'Discipline'}
                                             width={150}
                                             filters={disciplineFilters}
                                             render={(value, row) => row.disciplineName}
          />
          <Table.Column<ITournamentExtended> key={'eventId'} dataIndex={'eventId'} title={'Event'}
                                             filters={eventFilters}
                                             render={(value, row) => row.eventName}
          />
          <Table.Column<ITournamentExtended> key={'actions'} dataIndex={'id'}
                                             width={125} align={'right'}
                                             render={(value, row) => (
                                               <Dropdown overlay={() => actionMenu(row)} trigger={['click']}>
                                                 <Button>Actions <DownOutlined/></Button>
                                               </Dropdown>
                                             )}
          />
        </Table>
      </Col>
    </Row>
  )

}

const mapStateToProps = ({ tournamentExtended, event, tournamentCategory, discipline, authentication }: IAppState) => ({
  entities: tournamentExtended.entities,
  loading: tournamentExtended.loading,
  totalItems: tournamentExtended.totalItems,
  events: event.entities,
  eventsLoading: event.loading,
  categories: tournamentCategory.entities,
  categoriesLoading: tournamentCategory.loading,
  disciplines: discipline.entities,
  disciplinesLoading: discipline.loading,
  account: authentication.account,
})

const mapDispatchToProps = {
  getEntities,
  getEvents,
  getDisciplines,
  getCategories,
}

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(ActiveTournaments)